import { PRODUCT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { EMPTY_PROPERTY_VALUE } from '../../constants/EmptyPropertyValue';
import { getDataAttributes } from '../../utils/getDataAttributes';
import { FormattedPropertyDisplayedValue } from './FormattedPropertyDisplayedValue';
import { jsx as _jsx } from "react/jsx-runtime";
const FormattedPropertyBillingFrequency = props => {
  const {
    objectTypeId,
    objectId,
    getAdditionalPropertyValue,
    placeholder
  } = props;
  const isProductBundle = objectTypeId === PRODUCT_TYPE_ID && getAdditionalPropertyValue('hs_bundle_type', objectId, objectTypeId) === 'open';
  if (isProductBundle) {
    return /*#__PURE__*/_jsx("span", Object.assign({}, getDataAttributes(props), {
      children: placeholder !== null && placeholder !== void 0 ? placeholder : EMPTY_PROPERTY_VALUE
    }));
  }
  const {
    property,
    propertyValue,
    enableAutolinking,
    dataAttributes
  } = props;

  // This should stay try to stay in sync with the default render logic in FormattedPropertyV2.tsx
  return /*#__PURE__*/_jsx(FormattedPropertyDisplayedValue, {
    property: property,
    propertyValue: propertyValue,
    enableAutolinking: enableAutolinking,
    objectTypeId: objectTypeId,
    placeholder: placeholder,
    dataAttributes: dataAttributes
  });
};
FormattedPropertyBillingFrequency.displayName = 'FormattedPropertyBillingFrequency';
export default FormattedPropertyBillingFrequency;